import angular from 'angular';

import AddressBox from './address_box';
import Username from './username';
import ImageError from './image_error';
import ExternalLink from './external-link';

// application services
export default angular
  .module('app.directives', [])
  .directive('fmAddressBox', AddressBox)
  .directive('fmUsername', Username)
  .directive('fmImageError', ImageError)
  .directive('fmExternalLink', ExternalLink)
  .name;


// WEBPACK FOOTER //
// ./client/app/directives/directives.js